import React, { useState, useEffect } from 'react';
import './Hangar.scss';
import CommonCard, { ICommonCardContent } from '../../common/Pilots/CommonCard/CommonCard';
import PlaneIcon from './PlaneIcon';
import { BiPlus } from "react-icons/bi";
import AddAircraftPopup from "../AddAircraftPopup/AddAircraftPopup";
import DeleteAircraftPopup from "../DeleteAircraftPopup/DeleteAircraftPopup";
import { useTranslation } from 'react-i18next';
import { HANGAR_TILE_DETAILS,ADD_AIRCRAFT_DETAILS } from '../../../helper/constants';
import Tooltip from "@mui/material/Tooltip";
import HangarDetailedView from '../HangarDetailedView/HangarDetailedView';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setAircraftDetails } from "../../../store/hangar";
import { Button_V2 } from '../../common/Button_V2';

const Hangar = (props)=>{
    const [visibleItems, setVisibleItems] = useState<number>(9);
    const[addAircraftSection,setAddAircraftSection]=useState(false);
    const[hangarData,setHangarData]=useState([]);
    const[isloadMore,setIsloadMore]=useState(false);
    const[iseditAircraft,setIseditAircraft]=useState(false);
    const[iseditPopup,setIseditPopup]=useState(false);
    const[editAircraftData,setEditAircraftData]=useState([]);
    const[isdeletePopup,setIsDeletePopup]=useState(false);
    const[deleteAircraftData,setDeleteAircraftData]=useState(Number);

    // ── Hover / press states for Add Aircraft button ──
    const [addButtonHovered, setAddButtonHovered] = useState(false);
    const [addButtonPressed, setAddButtonPressed] = useState(false);

    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
   //Add Aircraft Section
   const addAircraft = () => {
    setAddAircraftSection(true);
    setIseditPopup(false);
    setIseditAircraft(false);
   };
   //CANCEL POPUP
   const cancelpopup =()=>{
    setAddAircraftSection(false);
   };

  //EDIT AIRCRAFT POPUP
  const editAircraft = () => {
    setIseditAircraft(true);
    setIseditPopup(true);
    };
 //ONCLICK OF HANGAR CARD
const handleCardLink = (element) => {
    dispatch(setAircraftDetails(element)); // Dispatch the action to set aircraft details in the Redux store
    navigate(`/hangardetailedview/${element.id}`);
};

  //CANCEL EDIT AIRCRAFT POPUP
  const cancelEditPopup = () => {
    setIseditAircraft(false);
    setIseditPopup(false);
   };

    //CANCEL DELETE POPUP
    const cancelDeletePopup = () => {
        setIsDeletePopup(false);
       };

  //FETCH HANGAR DETAILS
  const fetchHangarList=async()=>{
    try{
        const fetchHangarEndpoint="/api/techpub/v1/get-user-hangars";
        const response=await fetch(fetchHangarEndpoint,{
            method:'GET',
            headers:{
                'Content-Type':'application/json'
        }});
        const data=await response.json();
        const hangarList = Array.isArray(data.message?.result) ? data.message.result : [];
            setHangarData(hangarList);
            setVisibleItems(hangarList.length > 9 ? 9 : hangarList.length); // Set initial visible items
        }
    catch(error){
        console.log('Error in fetching Hangar Details:',error);
        }
 };

//FETCH HANGAR DETAILS ON PAGE LOAD
     useEffect(() => {
        fetchHangarList();
        }, []);
    // Set visible items based on hangar data length
    useEffect(() => {
        if (hangarData.length > 9) {
            setVisibleItems(9);
        } else {
            setVisibleItems(hangarData.length);
        }
    }, [hangarData]);

//CLICK OF LOAD MORE CTA
    const loadMoreItems = (hangarData) => {
       setIsloadMore(true);
       setVisibleItems(hangarData?.length);
        };
  //HANGAR TILE EDIT
    const handleEdit = (element) => {
      setIseditAircraft(true);
       setIseditPopup(true);
       setEditAircraftData(element);
        };
//HANGAR DELETE EDIT 
    const handleDelete = (element) => {
       setIsDeletePopup(true);
       setDeleteAircraftData(element.id);
    };

//ONCLICK OF LOAD LESS ITEMS
const loadlessItems =()=>{
    setIsloadMore(false);
    setVisibleItems(9);
};

//RENDER HANGARLIST VIEW
const renderHangarList = Array.isArray(hangarData) ?  hangarData?.slice(0,9)?.map((element: any, index: number) => {
        element.icon = PlaneIcon;
      const fullTitle = element?.aircraft_make ;
      const truncatedTitle = fullTitle.length > 18 ? fullTitle.substring(0, 18)+"..." : fullTitle;
      element.title = (
        <Tooltip title={fullTitle.length > 18 ? fullTitle:""}arrow
          componentsProps={{
            tooltip: {
              sx: {
                backgroundColor: "#384348",
                fontFamily: "PP Telegraf",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            arrow: {
              sx: {
                color: "#384348",
              },
            },
          }}
        >
        <span>{truncatedTitle}</span>
      </Tooltip>
              );
        const aircraftModel= element?.aircraft_model;
        const  truncatedModel = aircraftModel.length > 18 ? aircraftModel.substring(0, 18)+"..." : aircraftModel;
        element.extraTitle = (
            <Tooltip title={aircraftModel.length > 18 ? aircraftModel:""} arrow
            componentsProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#384348",
                  fontFamily: "PP Telegraf",
                  fontWeight: "400",
                  color: "#FFFFFF",
                },
              },
              arrow: {
                sx: {
                  color: "#384348",
                },
              },
            }}
          >
             <span>{truncatedModel}</span>
           </Tooltip>
                   );
                   const aircraftName= element?.aircraft_name?element?.aircraft_name:"N/A";
                   const  truncatedName = aircraftName.length > 18 ? aircraftName.substring(0, 18)+"..." : aircraftName;
                   element.description = (
                       <Tooltip title={aircraftName.length > 18 ? aircraftName:""}  arrow>
                        <span>{truncatedName}</span>
                      </Tooltip>
                              );
      element.extraDetails = "Software Version: "+element?.fms_version;
      element.id = element.id;
      element.menuOptions = {
            menuItems: ['Edit Aircraft Settings', 'Delete Aircraft'],
            menuActions: [(event) =>{
              handleEdit(element);
            },
                (event) => {
              handleDelete(element);
            }]
             };
        return <CommonCard key={index} {...element}  onClick={()=>handleCardLink(element)}/>;
      }):[];

  const noItemsMessage = t(HANGAR_TILE_DETAILS.TITLE);

  // ── Computed button style based on hover/press state ──
  const isAddButtonActive = addButtonHovered || addButtonPressed;
  const addButtonStyle = {
    backgroundColor: isAddButtonActive ? '#FF4F00' : 'transparent',
    color: isAddButtonActive ? '#ffffff' : '#1E1E25',
    borderColor: isAddButtonActive ? '#FF4F00' : '#1E1E25',
  };
  const addIconStyle = {
    color: isAddButtonActive ? '#ffffff' : '#1E1E25',
  };

  return (
        <div className='hangarContainer'>
            <div className='hangarHeader'>
                <div className='hangarCounterContent'>
                    <span>Your Hangar: ({Array.isArray(hangarData) ? hangarData.length : 0})</span>
                </div>

               {Array.isArray(hangarData) && hangarData?.length < 25 ? (
                <div className='hangarAddAircraftButtonContent'>
                    <Button_V2
                        type="secondary"
                        mode="default"
                        size="large"
                        onClick={() => {
                            (document.activeElement as HTMLElement)?.blur();
                            addAircraft();
                        }}
                        className="handerbuttonsecondry"
                        iconBefore={
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-plus" viewBox="0 0 16 16">
                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"/>
                            </svg>
                        }
                    >
                        {t(HANGAR_TILE_DETAILS.SUBTITLE)}
                    </Button_V2>
                    {/* <button
                      onClick={addAircraft}
                      onMouseEnter={() => setAddButtonHovered(true)}
                      onMouseLeave={() => { setAddButtonHovered(false); setAddButtonPressed(false); }}
                      onMouseDown={() => setAddButtonPressed(true)}
                      onMouseUp={() => setAddButtonPressed(false)}
                      style={addButtonStyle}
                    >
                      <BiPlus className='addAircraftIcon' style={addIconStyle}/>
                      {t(HANGAR_TILE_DETAILS.SUBTITLE)}
                    </button> */}
                </div>
                ):(
                    <div className='hangarDisableAircraftButtonContent'>
                       <Tooltip title={t(HANGAR_TILE_DETAILS.MAX_LIMIT)} arrow placement="left"
                       componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "#384348",
                                fontFamily: "PP Telegraf",
                                fontWeight: "400",
                                color: "#FFFFFF",
                            },
                        },
                        arrow: {
                            sx: {
                                color: "#384348",
                            },
                        },
                    }}
                       >
                    <button><BiPlus className='addAircraftIcon'/>{t(HANGAR_TILE_DETAILS.SUBTITLE)}</button>
                    </Tooltip>
                    </div>
                )}
                {addAircraftSection &&
                     <>
                      <AddAircraftPopup  show={addAircraft} closepop={cancelpopup} iseditPopup={false} fetchHangarList={fetchHangarList}/>
                     </>
                     }
            </div>

           {renderHangarList.length > 0 ? (
                <>
                <div className='hangarListContent'>
                    {renderHangarList}
                    </div>
                    {visibleItems<hangarData?.length  && (
                        <>
                     <div className='loadMoreButtonContent'>
                            <button onClick={()=>loadMoreItems(hangarData)}>{t(HANGAR_TILE_DETAILS.LOAD_MORE)}</button>
                        </div>
                         </>
                    )}
                    {visibleItems > 9 &&(
                     <>
                      <div className='hangarMoreContainer'>
                      {Array.isArray(hangarData) && hangarData?.slice(9)?.map((element: any, index: number) => {
                      element.icon = PlaneIcon;
                    const fullTitle = element?.aircraft_make ;
                    const truncatedTitle = fullTitle.length > 18 ? fullTitle.substring(0, 18)+"..." : fullTitle;
                   element.title = (
                     <Tooltip
                       title={fullTitle.length > 18 ? fullTitle : ""}
                       arrow
                       componentsProps={{
                         tooltip: {
                           sx: {
                             backgroundColor: "#384348",
                             fontFamily: "PP Telegraf",
                             fontWeight: "400",
                             color: "#FFFFFF",
                           },
                         },
                         arrow: {
                           sx: {
                             color: "#384348",
                           },
                         },
                       }}
                     >
                 <span>{truncatedTitle}</span>
                    </Tooltip>
              );
              const aircraftModel= element?.aircraft_model;
              const  truncatedModel = aircraftModel.length > 18 ? aircraftModel.substring(0, 18)+"..." : aircraftModel;
              element.extraTitle = (
                  <Tooltip title={aircraftModel.length > 18 ? aircraftModel:""}  arrow
                  componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: "#384348",
                                fontFamily: "PP Telegraf",
                                fontWeight: "400",
                                color: "#FFFFFF",
                            },
                        },
                        arrow: {
                            sx: {
                                color: "#384348",
                            },
                        },
                    }}
                  >
                   <span>{truncatedModel}</span>
                 </Tooltip>
                         );
                         const aircraftName= element?.aircraft_name?element?.aircraft_name:"N/A";
                         const  truncatedName = aircraftName.length > 18 ? aircraftName.substring(0, 18)+"..." : aircraftName;
                         element.description = (
                             <Tooltip
                             title={
                               aircraftName.length > 18 ? aircraftName : ""
                             }
                             arrow
                             componentsProps={{
                               tooltip: {
                                 sx: {
                                   backgroundColor: "#384348",
                                   fontFamily: "PP Telegraf",
                                   fontWeight: "400",
                                   color: "#FFFFFF",
                                 },
                               },
                               arrow: {
                                 sx: {
                                   color: "#384348",
                                 },
                               },
                             }}
                           >
                              <span>{truncatedName}</span>
                            </Tooltip>
                                    );
       element.extraDetails = "Software Version: "+element?.fms_version;
        element.id = element.id;
        element.menuOptions = {
            menuItems: [t(ADD_AIRCRAFT_DETAILS.EDIT_AIRCRAFT_SETTINGS),t(ADD_AIRCRAFT_DETAILS.DELETE_AIRCRAFT)],
            menuActions: [() => handleEdit(element), () => handleDelete(element)]
        };
         return <CommonCard key={index} {...element} onClick={()=>handleCardLink(element)}/>;
       })
}
 </div>
    <div className='loadMoreButtonContent'>
     <button onClick={loadlessItems}>{t(HANGAR_TILE_DETAILS.LOAD_LESS)}</button>
        </div>
        </>
         )
                 }
                </>
            ) : (
                <p className='noItemsMessage'>{noItemsMessage}</p>
            )}
            {iseditAircraft &&
            <>
             <AddAircraftPopup  show={editAircraft} closepop={cancelEditPopup} iseditPopup={true} editData={editAircraftData} fetchHangarList={fetchHangarList}/>
            </>
         }
         {isdeletePopup &&
         <>
         <DeleteAircraftPopup  show={isdeletePopup} closepop={cancelDeletePopup} isdeletePopup={true} deleteData={deleteAircraftData} fetchHangarList={fetchHangarList}/>
         </>}

        </div>
        );
};

export default Hangar;